<template>
  <figure :name="part.name" :style="styleObject" :data-color="color.name">
    <template v-for="picture in part.pictures" v-if="!reverse">
      <picture-svg class="picture front" :path="picture.image" :part="part"  v-if="!picture.is_back"></picture-svg>
    </template>
    <template v-for="picture in part.pictures" v-if="reverse">
      <picture-svg class="picture back" :path="picture.image" :part="part" v-if="picture.is_back"></picture-svg>
    </template>
  </figure>
</template>

<script>
  import Picture from './Picture.vue'
  export default {
    name: 'part',
    components: {
      'picture-svg': Picture
    },
    props: ['part', 'reverse'],
    computed:{
      styleObject(){
        if (this.part.hasOwnProperty('designs_part') && this.part.designs_part.color){
          return {
            fill: this.part.designs_part.color.color,
            stroke: '',
          }
        } else {
          return {
            fill: 'gray',
            stroke: '',
          }
        }
      },
      color(){
        if (this.part.hasOwnProperty('designs_part') && this.part.designs_part.color){
          return this.part.designs_part.color;
        } else {
          return '';
        }
      }
    }
  }
</script>
<style scoped>
  figure,.picture{
    position: absolute;
    margin: 0;
    top: 0;
    left: 0;
    width: 100%;
  }
</style>
